module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/badanie-techniczne-1b5606e0.png";